// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isEngagementLandingPagesAppGroupIdLimitsResult = objectOf({
  max_published_landing_pages: number,
  published_landing_pages_count: number,
});
